import { AbstractControl } from '@angular/forms';
import * as moment from 'moment';

export function ValidateMinDate(formControl: AbstractControl): any {
  if (formControl && formControl.value && moment(formControl.value)
    .isBefore(moment())) {
    return { minDate: true };
  }

  return null;
}
